import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getMonitoring(
  oauthTokenHeader: string,
  website_shared_uid: string,
  start_date: any,
  end_date: any
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/monitoring/?website_shared_uid=${website_shared_uid}&from=${start_date}&to=${end_date}`,
    oauthTokenHeader
  );
}

function getSystemMonitoring(
  oauthTokenHeader: string,
  start_date: any,
  end_date: any
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/monitoring/?systems=1&from=${start_date}&to=${end_date}`,
    oauthTokenHeader
  );
}

export const monitoringService = {
    getMonitoring,
    getSystemMonitoring
}